import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { title1nssp3ryhwuqj as title } from '../../theming/Titles.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { EditSpecifications2oyd85jvpdaul as EditSpecifications } from '../../components/specifications/EditSpecifications.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render_0,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_titlelss9nf4gv6ut as get_title } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Specifications$renderMainContent$slambdaClass;
function Specifications$renderMainContent$slambda() {
  if (Specifications$renderMainContent$slambdaClass === VOID) {
    class $ {
      ki2(spec, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Specifications$renderMainContent$slambdaClass = $;
  }
  return Specifications$renderMainContent$slambdaClass;
}
function Specifications$renderMainContent$slambda_0() {
  var i = new (Specifications$renderMainContent$slambda())();
  var l = (spec, $completion) => i.ki2(spec, $completion);
  l.$arity = 1;
  return l;
}
var SpecificationsClass;
function Specifications() {
  if (SpecificationsClass === VOID) {
    class $ {
      constructor() {
        this.sjn_1 = MemberRole_Manager_getInstance();
      }
      dhg() {
        return this.sjn_1;
      }
      thi(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_dp(0));
        title(view, 'Specifications');
        var tmp0_elvis_lhs_0 = ReactiveState__getOrNull_impl_1asnfp(get_selectedContractor().sah());
        var tmp_0 = tmp0_elvis_lhs_0 == null ? Companion_getInstance().k2p() : tmp0_elvis_lhs_0;
        var editSpecifications = new (EditSpecifications())(tmp_0, Specifications$renderMainContent$slambda_0());
        var tmp_1 = view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1), get_padded(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().ag2_1);
        view_0.bb9(get_AppDimensions().ag2_1);
        render(editSpecifications, view_0);
        view.hbb(p_0, view_0);
        view.lbb(tmp_1, view_0);
        _this__u8e3s4.hbb(p, view);
        _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render_0;
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'Specifications', Specifications, VOID, [ContractorPage()]);
    SpecificationsClass = $;
  }
  return SpecificationsClass;
}
//region block: exports
export {
  Specifications as Specifications3c29ii5k9j2f7,
};
//endregion

//# sourceMappingURL=Specifications.mjs.map
